<template>
  <v-bottom-sheet :hide-overlay="true" :persistent="true" v-model="show" inset>
    <div style="position:relative!important;">
      <v-sheet>
        <v-btn
          style="z-index:20; position:absolute; top:0; right:0;"
          @click="
            () => {
              this['Set/fetchSets']({ page: this.page });
              $router.push('/set');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card class="elevation-0">
          <v-window v-model="windows" vertical>
            <v-window-item value="details">
              <v-list>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Set Name</v-list-item-title>
                    <v-list-item-subtitle>{{ set.name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Set Price</v-list-item-title>
                    <v-list-item-subtitle>{{ set.price }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-window-item>
            <v-window-item value="items">
              <setshowitems :items="set.items" :set="set" />
            </v-window-item>
          </v-window>
          <v-card-actions>
            <v-chip class="mx-2" :disabled="windows === 'details'" @click="windows = 'details'">
              Details
            </v-chip>
            <v-chip class="mx-2" :disabled="windows === 'items'" @click="windows = 'items'">
              Set Composition
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn @click="deleteSet" outlined color="red">
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-sheet>
    </div>
  </v-bottom-sheet>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import setshowitems from './SetShowItems';

export default {
  data: function() {
    return {
      windows: 'details',
      chipFilter: 'instock'
    };
  },
  components: {
    setshowitems
  },
  beforeMount() {
    if (this.show) {
      this['Set/getSet']({ id: this.$route.params.id }).finally(() => {
        // console.log(this.set.name);
        // console.log(this.set.name == '');
        if (this.set.name == '') {
          this.$router.push('/set');
        }
      });
    }
  },
  props: {
    show: false,
    page: 0
  },
  computed: {
    ...mapState({
      set(state) {
        if (typeof state.Set.set.data == 'undefined') {
          return {
            name: '',
            amount: '',
            sale_id: '',
            items: []
          };
        } else {
          return {
            name: state.Set.set.data.name,
            amount: state.Set.set.data.amount,
            sale_id: state.Set.set.data.sale_id,
            items: state.Set.set.data.items
          };
        }
      }
    })
  },
  methods: {
    ...mapActions(['Set/fetchSets', 'Set/getSet']),
    deleteSet() {
      axios
        .delete(`api/v1/set/${this.$route.params.id}`)
        .then(response => {
          this.$store.commit('SET_SNACK_BAR', {
            message: 'Set deleted...',
            color: 'success'
          });
          this['Set/fetchSets']({ page: this.page });
          this.$router.push('/set');
        })
        .catch(error => {
          if (error.response.status == 403) {
            this.$store.commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
          } else {
            this.$store.commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data.errors['id'][0],
                color: 'error'
              },
              { root: true }
            );
          }
        })
        .finally(() => {});
    },
    goToEdit() {
      this.$router.push(`/set/${this.$route.params.id}/edit`);
    }
  }
};
</script>
